<template>
    <div id="app">
      <div>
        <confirm ref="confirm" />
        <loader v-model="statusval.loading" />
        <arksnackbar v-model="statusval" />
      </div>
  
      <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>
                  <v-layout align-center>
                    Satıcı Aktarımı
                  </v-layout>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="green" text @click="downloadSampleFile">
                  Örnek Dosyayı İndir
                </v-btn>
              </v-toolbar>
            </v-flex>
  
            <v-container fluid>
              <v-layout row wrap align-center>
                <v-flex xs12 sm12 md6>
                  <v-layout align-center>
                    <v-form
                      ref="formaktarim"
                      method="post"
                      enctype="multipart/form-data"
                      v-model="valid"
                      lazy-validation
                    >
                      <input
                        hidden
                        type="file"
                        ref="files"
                        multiple
                        accept=".csv, .xls, .xlsx"
                        @change="handleFilesUpload"
                      />
                    </v-form>
                    <v-btn color="info" dark @click="addFiles">
                      <v-icon left>attach_file</v-icon>
                      Aktarım Dosyası Seçiniz
                    </v-btn>
  
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="files.length"
                          color="info"
                          fab
                          small
                          class="ml-3"
                          @click="submitFiles"
                          :loading="statusval.loading"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark>mdi-redo</v-icon>
                        </v-btn>
                      </template>
                      <span>Seçilenleri Aktar</span>
                    </v-tooltip>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-layout justify-start>
                    <v-alert
                      :value="true"
                      :color="alertcolor"
                      icon="check_circle"
                      outlined
                      class="ma-0"
                      style="max-width: 100%"
                    >
                      {{ alertmessage }}
                    </v-alert>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
  
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="info">
                  <v-toolbar-title>
                    Aktarılan Satıcılar
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    flat
                    solo-inverted
                    hide-details
                    v-model="search3"
                    label="Ara"
                    append-icon="search"
                  />
                </v-toolbar>
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :rows-per-page-items="[20, 500]"
                    :items="itemsok"
                    :search="search3"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>{{ props.item.SatirNo }}</td>
                        <td>{{ props.item.aciklama }}</td>
                        <td>{{ props.item.SaveInput ? props.item.SaveInput.Aciklama : '-' }}</td>
                      </tr>
                    </template>
                    <template slot="no-results">
                      <v-alert :value="true" color="error" icon="warning">
                        {{ search3 }} için kayıt bulunamadı.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
  
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="red">
                  <v-toolbar-title>
                    Aktarılamayan Satıcılar
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    flat
                    solo-inverted
                    hide-details
                    v-model="search4"
                    label="Ara"
                    append-icon="search"
                  />
                </v-toolbar>
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :rows-per-page-items="[20, 500]"
                    :items="itemsno"
                    :search="search4"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>{{ props.item.SatirNo }}</td>
                        <td>{{ props.item.aciklama }}</td>
                        <td>{{ props.item.SaveInput ? props.item.SaveInput.Aciklama : '-' }}</td>
                      </tr>
                    </template>
                    <template slot="no-results">
                      <v-alert :value="true" color="error" icon="warning">
                        {{ search4 }} için kayıt bulunamadı.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
      </v-app>
    </div>
  </template>
  
  
    
    
    
    <script>
    import confirm from '@/components/app/coper/comp/confirm.vue';
    import loader from '@/components/app/coper/comp/loader.vue';
    import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue';
    import yetkidialog from '@/components/app/customcomp/yetkidialog.vue';
    import helpers from '@/components/app/customcomp/helpers.js';
    import tool from '@/components/app/coper/tools';
    
    export default {
      props: ['value', 'title', 'status', 'tarihfield', 'menuitems'],
      components: { confirm, loader, arksnackbar, yetkidialog },
      data() {
        return {
          files: [],
          itemsok: [],
          itemsno: [],
          alertcolor: 'red',
          alertmessage: 'Henüz dosya seçilmedi',
          search3: '',
          search4: '',
          valid: true,
          tooltip: false,
          headers: [
            { text: 'Satır No', value: 'SatirNo' },
            { text: 'Açıklama', value: 'aciklama' },
            { text: 'Durum', value: 'SaveInput.Aciklama' },
          ],
        };
      },
      computed: {
        statusval() {
          return this.status != null ? this.status : tool.NewSatatus();
        },
      },
      methods: {
        menuClick(index) {
          this.$emit('menuclick', index);
        },
        handleFilesUpload() {
          this.files = Array.from(this.$refs.files.files);
          if (this.files.length > 0) {
            this.alertcolor = 'success';
            this.alertmessage = `${this.files.length} adet dosya seçildi`;
          } else {
            this.alertcolor = 'red';
            this.alertmessage = 'Henüz dosya seçilmedi';
          }
        },
        addFiles() {
          this.$refs.files.click();
        },
        async submitFiles() {
          const confirmResult = await this.$refs.confirm.open(
            'Satıcı Aktarımı',
            'Seçilen dosyaları aktarmak istediğinizden emin misiniz?',
            { color: 'red' }
          );
          if (!confirmResult) return;
    
          const formData = new FormData();
          this.files.forEach((file, i) => {
            formData.append(`files[${i}]`, file);
          });
    
          this.statusval.loading = true;
          try {
            const response = await tool.api_file_post(this, 'CariStream/SaticiAktarimStream', formData);
    
            const data = response.body || response; // response.body varsa onu kullan, yoksa direkt response
            this.itemsok = data.filter((x) => x.basarili);
            this.itemsno = data.filter((x) => !x.basarili);
          } catch (err) {
            console.error('Aktarım hatası:', err);
            this.alertcolor = 'red';
            this.alertmessage = 'Aktarım sırasında hata oluştu';
          } finally {
            this.statusval.loading = false;
          }
        },
        async downloadSampleFile() {
    const fileName = 'import_satici_aktarim.xlsx';
    const prm = { FileName: fileName };
  
    this.statusval.loading = true;
  
    try {
      const response = await tool.api_post_FileDownload(this, 'CariStream/DownloadFile', prm);
      tool.CreateDownloadLink(response, fileName);
    } catch (error) {
      console.error('Dosya indirme hatası:', error);
      this.alertcolor = 'red';
      this.alertmessage = 'Dosya indirilemedi.';
    } finally {
      this.statusval.loading = false;
    }
  }
  
  
      },
    };
    </script>
    
    